import { ScrollingModule } from "@angular/cdk/scrolling";
import { STEPPER_GLOBAL_OPTIONS } from "@angular/cdk/stepper";
import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatChipsModule } from "@angular/material/chips";
import { MatNativeDateModule, MAT_DATE_LOCALE } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatStepperModule } from "@angular/material/stepper";
import { MatToolbarModule } from "@angular/material/toolbar";
import { TranslateModule } from "@ngx-translate/core";
import { NgxMaskModule } from "ngx-mask";
import { SharedModule } from "./../../shared/shared.module";
import { RegistrarCheckoutComponent } from "./page/registrar-checkout/registrar-checkout.component";
import { RegistrarFormComponent } from "./page/registrar-form/registrar-form.component";
import { RegistrarThirdpartyComponent } from "./page/registrar-thirdparty/registrar-thirdparty.component";
import { RegistrarViaInviteComponent } from "./page/registrar-via-invite/registrar-via-invite.component";
import { RegistrarComponent } from "./page/registrar.component";
import { RegistrarRoutingModule } from "./registrar.routing";

@NgModule({
    declarations: [
        RegistrarComponent,
        RegistrarFormComponent,
        RegistrarThirdpartyComponent,
        RegistrarViaInviteComponent,
        RegistrarCheckoutComponent,
        RegistrarCheckoutComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        MatToolbarModule,
        RegistrarRoutingModule,
        MatStepperModule,
        MatCardModule,
        MatFormFieldModule,
        ScrollingModule,
        MatSlideToggleModule,
        MatChipsModule,
        MatInputModule,
        MatButtonModule,
        FormsModule,
        ReactiveFormsModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatIconModule,
        TranslateModule,
        NgxMaskModule.forRoot()
    ],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: "pt-BR" },
        {
            provide: STEPPER_GLOBAL_OPTIONS,
            useValue: { displayDefaultIndicatorType: false }
        }
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RegistrarModule {}
